module.exports = __webpack_public_path__ + "static/customemail-5666d80c1093026060b69fe9264fd9e3.png";